import type { PageOrientation } from 'components/editor/shared/gridConfig.ts';
import useDownloadAsPdf from './useDownloadAsPdf.ts';

type PdfDownloadButtonForExportingServiceProps = {
  pageOrientation?: PageOrientation;
};

const PdfDownloadButtonForExportingService = ({ pageOrientation }: PdfDownloadButtonForExportingServiceProps) => {
  const printPdf = useDownloadAsPdf({
    pageOrientation,
    printingFunction: async (iframe) => {
      document.write(iframe.contentDocument?.documentElement.outerHTML || '');
    },
  });

  return <button id="print-pdf-button" hidden={true} onClick={printPdf} />;
};

export default PdfDownloadButtonForExportingService;
